'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.requestSeatUpgrade = undefined;

var _I18n = require('I18n');

var _I18n2 = _interopRequireDefault(_I18n);

var _ImmutableMerchandiseIdMap = require('self-service-api/constants/ImmutableMerchandiseIdMap');

var _ImmutableMerchandiseIdMap2 = _interopRequireDefault(_ImmutableMerchandiseIdMap);

var _requestNotificationsApi = require('ui-addon-upgrades/_core/common/api/requestNotificationsApi');

var _tracker = require('ui-addon-upgrades/_core/common/eventTracking/tracker');

var tracker = _interopRequireWildcard(_tracker);

var _wrapWithErrorMonitoring = require('ui-addon-upgrades/_core/common/reliability/wrapWithErrorMonitoring');

var _wrapWithErrorMonitoring2 = _interopRequireDefault(_wrapWithErrorMonitoring);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var requestSeatUpgrade = exports.requestSeatUpgrade = (0, _wrapWithErrorMonitoring2.default)('requestSeatUpgrade', function (upgradeData) {
  var seatedProductOwned = upgradeData.seatedProductOwned,
      upgradeProduct = upgradeData.upgradeProduct;

  var productProperties = _ImmutableMerchandiseIdMap2.default[seatedProductOwned];
  var defaultName = _I18n2.default.text('upgrades.products.default');
  var productName = productProperties ? productProperties.productName || defaultName : defaultName;
  return (0, _requestNotificationsApi.sendRequestAccessNotification)(productName).then(function () {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('requestUpgradeInteraction', {
      action: 'request seat succeeded',
      merchandiseId: seatedProductOwned,
      upgradeProduct: upgradeProduct
    });
    return { hasError: false };
  }).catch(function (e) {
    // ********** PUBLIC EVENT **********
    // Public Events help teams across HubSpot automate work and customize experiences based on user actions.
    // Speak with #product-insight and your PM before any shipping any changes to this event incl. event name, properties, values, and when it occurs.
    // Read more about Public Events on the wiki: https://wiki.hubspotcentral.net/display/PM/Public+Events+-+Amplitude+events+ready+for+HubSpot+team+use+and+automation
    tracker.track('requestUpgradeInteraction', {
      action: 'request seat failed',
      merchandiseId: seatedProductOwned,
      upgradeProduct: upgradeProduct
    });

    if (window.Raven) {
      window.Raven.captureMessage('Request seat notification failed', {
        extra: { error: e }
      });
    }
    return { hasError: true };
  });
});


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/ui-addon-upgrades/static-9.1086/js/_core/upgrade/requestSeatUpgrade.js
// module id = 510
// module chunks = 3 4 5